import {Injectable} from '@angular/core';
import {ApiService} from './api';

@Injectable({providedIn: 'root'})
export class ReportsService {
  path: string = '/api';
  constructor(private apiService: ApiService) {}

  public getChannelResponseReport(airline_id: string, start_date: string, end_date: string) {
    return this.apiService
      .get(
        // tslint:disable-next-line
        `${
          this.path
        }/channel_reports?airline_id=${airline_id}&start_date=${start_date}&end_date=${end_date}`,
      );
  }

  public getApiPhotosReport(
    airline_id: string,
    start_date: string,
    end_date: string,
    channel_id?: string,
  ) {
    return this.apiService
      .get(
        `${
          this.path
        }/airlines/${airline_id}/photo_impressions?start_date=${start_date}&end_date=${end_date}&group=${channel_id}`,
      );
  }
}
